/**
 * Deals Page - Migrated to use EntitiesList
 *
 * This page now uses the generic EntitiesList component with
 * Deals-specific configuration for a standardized experience.
 */

import React from "react";
import { Link } from "react-router-dom";
import { PlusIcon } from "@heroicons/react/24/outline";

// Generic EntitiesList component and entity configurations
import EntitiesList from "../components/entities/EntitiesList";
import DealsConfig from "../components/entities/deals/DealsConfig";
import DealsColumns from "../components/entities/deals/DealsColumns";
import * as DealsMetrics from "../components/entities/deals/DealsMetrics";

// API hooks
import { useDeals } from "../hooks/useApi";

/**
 * Deals Page Component
 *
 * Uses the generic EntitiesList with Deals-specific configuration
 * to provide a consistent, standardized experience.
 */
function Deals() {
  // API hooks for deals data
  const {
    items: deals = [],
    loading,
    error,
    refresh: refetch,
    clearError,
  } = useDeals();

  // Custom Header Actions component for Deals
  const DealsHeaderActions = () => (
    <Link
      to="/new-deal"
      className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
    >
      <PlusIcon className="h-4 w-4 mr-2" />
      New Deal
    </Link>
  );

  // Custom Empty State Actions for Deals
  const DealsEmptyStateActions = () => (
    <Link
      to="/new-deal"
      className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
    >
      <PlusIcon className="h-4 w-4 mr-2" />
      Create First Deal
    </Link>
  );

  return (
    <EntitiesList
      // Entity configuration
      entityConfig={DealsConfig}
      entityColumns={DealsColumns}
      entityMetrics={DealsMetrics}
      // Data and state
      entities={deals}
      loading={loading}
      error={error}
      // API functions
      refreshFunction={refetch}
      clearErrorFunction={clearError}
      // Custom components
      HeaderActions={DealsHeaderActions}
      EmptyStateActions={DealsEmptyStateActions}
      // Layout preferences
      layout="table"
    />
  );
}

export default Deals;
